<template>
    <div class="input-wrapper">

      <label
        for="companyName"
        class="input-wrapper__label"
      >{{ ($t('companyFormData.companyName')) }} *</label>

      <input
        id="companyName"
        name="companyName"
        autocomplete="off"
        required
        type="text"
        maxlength="254"
        placeholder="INFORM GmbH"
        class="input-wrapper__input"
        :class="{ 'invalid-input': errorObj.companyName }"
        :value="companyName"
        @input="(e) => {debouncedInputValidate($emit('update:modelValue', e.target.value)); companyName=e.target.value}"
        @blur="validateOnBlur"
        @keydown.tab="handleTabKey"
      />

      <div
          v-if="errorObj.companyName"
          class="input-wrapper__label input-wrapper__label--error">
          {{ $t(errorObj.companyName) }}
      </div>

    </div>
</template>

<script>
import { ref } from 'vue'
import useSignup from '@/composables/useSignup'
import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'
import useTabKeyValidation from '@/composables/useTabKeyValidation'

export default {
  setup () {
    const { t } = useI18n()

    // refs/reactive data
    const companyName = ref('')

    const inputValidate = () => {
      nameInputsValidate('companyName', companyName.value)
    }

    const { validateOnBlur } = useTabKeyValidation(inputValidate)

    // return values 'errorObj, nameFieldsValidate' from useSignup
    const { errorObj, nameInputsValidate } = useSignup(t)

    const debouncedInputValidate = debounce(inputValidate, 500)

    return { companyName, debouncedInputValidate, inputValidate, validateOnBlur, t, errorObj }
  }
}
</script>

<style lang="scss" scoped>
 .input-wrapper {
    position: relative;
    &__input {
      @include input;

      &:focus {
          @include input-focus;
      }
    }
    &__label {
      text-align: left;

      @include input-label;

      &--error {
        @include error-message;
        &::after {
          content: '';
          width: var(--spacing-m);
          height: var(--spacing-m);
          position: absolute;
          top: 36px;
          right: 12px;
          background-image: url('../assets/images/exclamation-circle.svg');
          background-position: center center;
          background-repeat: no-repeat;
          z-index: -1;

          @include respond-to('small') {
            top: 40px;
          }
        }
      }
    }
    .invalid-input {
      @include invalid-input;
    }

    @include shake;
  }
</style>
